import React from 'react';
import Icon from '../ui/Icon';
import './MilestoneCard.css';

// `milestone`: { id, label, description, held, progress: {current, target} }.
// Journey markers, distinct in presentation from the achievement badge grid
// even where a few conditions are the same real signal — no unlock date is
// shown (not tracked yet, see docs/UI_UX_ARCHITECTURE.md §5/§12).
const MilestoneCard = ({ milestone }) => {
  const pct = milestone.progress.target > 0
    ? Math.min(100, Math.round((milestone.progress.current / milestone.progress.target) * 100))
    : 0;

  return (
    <div className={`z-milestone ${milestone.held ? 'z-milestone--held' : ''}`}>
      <span className={`z-milestone-dot ${milestone.held ? 'z-milestone-dot--held' : ''}`} aria-hidden="true">
        {milestone.held && <Icon name="check" size={12} strokeWidth={3} />}
      </span>
      <div className="z-milestone-body">
        <span className="z-milestone-label">{milestone.label}</span>
        {!milestone.held && (
          <>
            <div className="z-milestone-track"><div className="z-milestone-fill" style={{ width: `${pct}%` }} /></div>
            <span className="z-milestone-progress-text">{milestone.progress.current} / {milestone.progress.target}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default MilestoneCard;
